// Framework and third-party non-ui
import React, { Component } from "react";

// Redux operations and local helpers/utils/modules
import Context from "../../../context/Context";
import * as component from "../../../components/util/component";

// Component specific modules (Component-styled, etc.)
import {
  ContentWrapper,
  HeaderContainer,
  Header,
  ContentContainer,
  InfoCardHeader,
  InfoCard,
  InfoGroup,
  InfoHeader,
  InfoItem
} from "../../styles/backstageStyles";

// App components

// Third-party components (buttons, icons, etc.)

// JSON

// CSS

export default class Summary extends Component {
  _itemProperties;
  _versionProperties;

  constructor(props) {
    super(props);
    this.state = component.newState({
      isWorking: false
    });
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  render() {
    const i18n = Context.instance.i18n;
    const plan = Context.instance.spaceplanner.activePlan;
    const info = (plan && plan.getMetaInfo()) || {}

    return (
      <ContentWrapper>
        <HeaderContainer>
          <Header>{i18n.spaceplanner.backstage.summary.caption}</Header>
        </HeaderContainer>
        <ContentContainer>
          <InfoCardHeader>
            {i18n.spaceplanner.backstage.summary.cards.general.label}
          </InfoCardHeader>
          <InfoCard>
            <InfoGroup>
              <InfoHeader>
                {i18n.spaceplanner.backstage.summary.cards.general.planName}
              </InfoHeader>
              <InfoItem>{info.title}</InfoItem>
            </InfoGroup>
            <InfoGroup>
              <InfoHeader>
                {i18n.spaceplanner.backstage.summary.cards.general.owner}
              </InfoHeader>
              <InfoItem>{info.owner}</InfoItem>
            </InfoGroup>
            <InfoGroup>
              <InfoHeader>
                {i18n.spaceplanner.backstage.summary.cards.general.created}
              </InfoHeader>
              <InfoItem>{info.created}</InfoItem>
            </InfoGroup>

            <InfoGroup>
              <InfoHeader>
                {i18n.spaceplanner.backstage.summary.cards.general.modified}
              </InfoHeader>
              <InfoItem>{info.modified}</InfoItem>
            </InfoGroup>

            <InfoGroup>
              <InfoHeader>
                {i18n.spaceplanner.backstage.summary.cards.general.description}
              </InfoHeader>
              <InfoItem>{info.summary}</InfoItem>
            </InfoGroup>
          </InfoCard>
        </ContentContainer>
      </ContentWrapper>
    );
  }
}
